// import "./Content.css";

// const HungerBlog = () => {
//   return (
//     <div className="content-container">

//       <h1>GLOBAL WEEKS OF SERVICE</h1>

//       <h2>THE ROAR AGAINST HUNGER</h2>

//       <p><b>How Lions Across India United to Feed Hope</b></p>

//       <p><b>January 3–11, 2026 | A Historic Week That Nourished Millions</b></p>

//       <p>
//         When International President Lion A. P. Singh envisioned a series of Global Weeks of Service for India, he imagined something unprecedented—a nationwide movement where Lions would rise together to address humanity's most pressing challenges. In January 2026, that vision became a magnificent reality as Lions across India launched "Be the Roar Against Hunger"—the second historic Service Week that touched millions of lives.
//       </p>

//       <p>
//         From the snow-capped regions of Kashmir to the tropical shores of Kanyakumari, Lions donned their service vests with a singular mission: no one in their community would go hungry. What unfolded over nine days was nothing short of a revolution in compassionate action.
//       </p>

//       <h3>THE ARCHITECTS OF SUCCESS</h3>

//       <p>
//         The success of Hunger Week was made possible through visionary leadership at every level. International President Lion A. P. Singh provided the inspiration that ignited this movement—his clarion call for service resonated across the globe. The Lions Council of India (LCOI) under Chairperson PID Lion G. Babu Rao, Secretary PID Lion Pravin Chhajer, Treasurer PID Lion Vijaykumar Raju and the Leadership provided unwavering motivation and institutional support that empowered Districts to mobilise effectively.
//       </p>

//       <p>
//         The operational direction came from Service Weeks Coordinator LCOI—PID Lion Narendra Bhandari, whose strategic guidance ensured seamless coordination across Multiple Districts. He along with the team comprising of PDG Lion Abhay Shastri, Lion m nagaRAJU and Lion Pinkesh Patoria worked tirelessly on developing comprehensive toolkits, presentations, handouts, implementation plans, follow-up mechanisms, and the awards framework that recognised excellence across the nation.
//       </p>

//       <h3>THE SCALE OF COMPASSION</h3>

//       <p>
//         Building on the success of the Mental Health & Wellness Service Week in October 2025, this dedicated team mobilised Lions across the nation for an equally transformative response to hunger.
//       </p>

//       <p>
//         "Not on our watch. Where there is hunger, there will be a Lion." — This became our sacred vow.
//       </p>

//       <h3>ROOTED IN CULTURE AND FAITH</h3>

//       <p>
//         What made Hunger Week resonate so deeply was its connection to India's spiritual heritage. In Hindu philosophy, Anna Daan (gift of food) is revered as Maha Daan—the greatest gift. The Sikh tradition of Langar inspired our community kitchen models. Islamic principles of Sadaqah, Christian teachings of serving the hungry, and Buddhist-Jain traditions of compassionate giving—all found expression in Lions' service. Feeding the hungry honours the best of every faith.
//       </p>

//       <h3>A WEEK OF EXTRAORDINARY ACTION</h3>

//       <ul>
//         <li>Community Kitchens (Khichadi Ghar)</li>
//         <li>Food Donation Drives</li>
//         <li>Hunger Relief Kits</li>
//         <li>School Nutrition Programmes</li>
//         <li>Senior Citizen Support</li>
//       </ul>

//       <h3>RECOGNISING EXCELLENCE: HUNGER WEEK AWARDS 2026</h3>

//       <p>
//         The overwhelming response to Hunger Week was reflected in the awards programme. A total of 617 nominations were received from 427 Clubs across 54 Districts and 12 Multiple Districts—a testament to the nationwide participation.
//       </p>

//       <h3>THE COLLECTIVE ROAR</h3>

//       <p>
//         The response from Multiple District 322 was particularly remarkable, leading with 130 nominations, followed by MD 317 (83), MD 320 (62), and MD 3233 (52).
//       </p>

//       <h3>THE JOURNEY CONTINUES</h3>

//       <p>
//         "When we feed one person, we nourish humanity. When Lions unite, hunger doesn't stand a chance."
//       </p>

//     </div>
//   );
// };

// export default HungerBlog;



import { useNavigate } from "react-router-dom";
import "./Content.css";

// const HungerBlog = () => {
//   return (
//     <div
//       style={{
//         maxWidth: "900px",
//         margin: "40px auto",
//         padding: "30px",
//         fontFamily: "Arial, sans-serif",
//         lineHeight: "1.7",
//         color: "#333",
//         backgroundColor: "#fff",
//         borderRadius: "10px",
//         boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//       }}
//     >
//       <h4 style={{ textAlign: "center", color: "#777", letterSpacing: "1px" }}>
//         GLOBAL WEEKS OF SERVICE
//       </h4>

//       <h1
//         style={{
//           textAlign: "center",
//           color: "#0b3d91",
//           marginBottom: "10px",
//         }}
//       >
//         THE ROAR AGAINST HUNGER
//       </h1>

//       <p
//         style={{
//           textAlign: "center",
//           fontStyle: "italic",
//           color: "#b22222",
//           marginBottom: "20px",
//         }}
//       >
//         How Lions Across India United to Feed Hope
//       </p>

//       <div
//         style={{
//           height: "5px",
//           width: "120px",
//           backgroundColor: "#c9a227",
//           margin: "10px auto 20px",
//           borderRadius: "5px",
//         }}
//       ></div>

//       <p style={{ textAlign: "center", color: "#666", marginBottom: "30px" }}>
//         January 3–11, 2026 | A Historic Week That Nourished Millions
//       </p>

//       <p>
//         When International President Lion A. P. Singh envisioned a series of Global Weeks of Service for India, he imagined something unprecedented—a nationwide movement where Lions would rise together to address humanity's most pressing challenges. In January 2026, that vision became a magnificent reality as Lions across India launched "Be the Roar Against Hunger"—the second historic Service Week that touched millions of lives.
//       </p>

//       <p>
//         From the snow-capped regions of Kashmir to the tropical shores of Kanyakumari, Lions donned their service vests with a singular mission: no one in their community would go hungry. What unfolded over nine days was nothing short of a revolution in compassionate action.
//       </p>

//       <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
//         THE ARCHITECTS OF SUCCESS
//       </h3>

//       <p>
//         The success of Hunger Week was made possible through visionary leadership at every level. International President Lion A. P. Singh provided the inspiration that ignited this movement—his clarion call for service resonated across the globe. The Lions Council of India (LCOI) under Chairperson PID Lion G. Babu Rao, Secretary PID Lion Pravin Chhajer, Treasurer PID Lion Vijaykumar Raju and the Leadership provided unwavering motivation and institutional support that empowered Districts to mobilise effectively.
//       </p>

//       <p>
//         The operational direction came from Service Weeks Coordinator LCOI—PID Lion Narendra Bhandari, whose strategic guidance ensured seamless coordination across Multiple Districts. He along with the team comprising of PDG Lion Abhay Shastri, Lion M. Naga Raju and Lion Pinkesh Patoria worked tirelessly on developing comprehensive toolkits, presentations, handouts, implementation plans, follow-up mechanisms, and the awards framework that recognised excellence across the nation.
//       </p>

//       <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
//         THE SCALE OF COMPASSION
//       </h3>

//       <p>
//         Building on the success of the Mental Health & Wellness Service Week in October 2025, this dedicated team mobilised Lions across the nation for an equally transformative response to hunger.
//       </p>

//       <p>
//         "Not on our watch. Where there is hunger, there will be a Lion."
//       </p>

//       <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
//         ROOTED IN CULTURE AND FAITH
//       </h3>

//       <p>
//         What made Hunger Week resonate so deeply was its connection to India's spiritual heritage...
//       </p>

//       <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
//         A WEEK OF EXTRAORDINARY ACTION
//       </h3>

//       <ul>
//         <li>Community Kitchens (Khichadi Ghar)</li>
//         <li>Food Donation Drives</li>
//         <li>Hunger Relief Kits</li>
//         <li>School Nutrition Programmes</li>
//         <li>Senior Citizen Support</li>
//       </ul>

//       <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
//         RECOGNISING EXCELLENCE: HUNGER WEEK AWARDS 2026
//       </h3>

//       <p>
//         The overwhelming response to Hunger Week was reflected in the awards programme...
//       </p>

//       <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
//         THE COLLECTIVE ROAR
//       </h3>

//       <p>
//         The response from Multiple District 322 was particularly remarkable...
//       </p>

//       <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
//         THE JOURNEY CONTINUES
//       </h3>

//       <p>
//         "When we feed one person, we nourish humanity. When Lions unite, hunger doesn't stand a chance."
//       </p>
//     </div>
//   );
// };

// export default HungerBlog;

const HungerBlog = () => {
      const navigate = useNavigate();
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "40px auto",
        padding: "30px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.7",
        color: "#333",
        backgroundColor: "#fff",
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >

        
                   <button className="back-btn" onClick={() => navigate(-1)}>
        ← Go Back
      </button>
      <h4 style={{ textAlign: "center", color: "#777", letterSpacing: "1px" }}>
        GLOBAL WEEKS OF SERVICE
      </h4>

      <h1 style={{ textAlign: "center", color: "#0b3d91" }}>
        THE ROAR AGAINST HUNGER
      </h1>

      <p style={{ textAlign: "center", fontStyle: "italic", color: "#b22222" }}>
        How Lions Across India United to Feed Hope
      </p>

      <div
        style={{
          height: "5px",
          width: "120px",
          backgroundColor: "#c9a227",
          margin: "10px auto 20px",
          borderRadius: "5px",
        }}
      />

      <p style={{ textAlign: "center", color: "#666" }}>
        January 3–11, 2026 | A Historic Week That Nourished Millions
      </p>

      <p>
        {/* When International President Lion A. P. Singh envisioned a series of
        Global Weeks of Service for India, he imagined something unprecedented—a
        nationwide movement where Lions would rise together to address
        humanity's most pressing challenges. */}
        When International President Lion A. P. Singh envisioned a series of Global Weeks of Service for India, 
        he imagined something unprecedented—a nationwide movement where Lions would rise together to address humanity's most pressing challenges.
         In January 2026, that vision became a magnificent reality as Lions across India launched 
        <b>"Be the Roar Against Hunger"</b> —the second historic Service Week that touched millions of lives.
      </p>

      {/* <p>
        In January 2026, that vision became a magnificent reality as Lions across
        India launched <b>"Be the Roar Against Hunger"</b>—the second historic
        Service Week that touched millions of lives.
      </p> */}

      <p>
        From the snow-capped regions of Kashmir to the tropical shores of Kanyakumari, Lions donned their service vests with a singular mission:
         no one in their community would go hungry. What unfolded over nine days was nothing short of a revolution in compassionate action.
      </p>

      <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
        THE ARCHITECTS OF SUCCESS
      </h3>

      <p>
        {/* The success of Hunger Week was made possible through visionary
        leadership. The Lions Council of India (LCOI) leadership provided strong
        support that empowered districts to mobilise effectively. */}
        The success of Hunger Week was made possible through visionary leadership at every level.
         <b>International President Lion A. P. Singh</b> provided the inspiration that ignited this movement—his clarion call for service resonated across the globe.
            <b>The Lions Council of India (LCOI) </b> under   <b>Chairperson PID Lion G. Babu Rao, Secretary PID Lion Pravin Chhajer, 
          Treasurer PID Lion Vijaykumar Raju and the 
        Leadership </b> provided unwavering motivation and institutional support that empowered Districts to mobilise effectively.
      </p>

      <p>
      The operational direction came from <b> Service Weeks Coordinator LCOI—PID Lion Narendra Bhandari,</b>
      whose strategic guidance ensured seamless coordination across Multiple Districts. He along with the team comprising of <b>PDG Lion Abhay Shastri, 
      Lion m nagaRAJU and Lion Pinkesh Patoria </b>worked tirelessly on developing comprehensive toolkits, presentations, handouts, 
      implementation plans, follow-up mechanisms, and the awards framework that recognised excellence across the nation.
      </p>

      <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
        THE SCALE OF COMPASSION
      </h3>

      <p>
       Building on the success of the Mental Health & Wellness Service Week in October 2025, 
       this dedicated team mobilised Lions across the nation for an equally transformative response to hunger.
      </p>

      <p>
        <i>
          "Not on our watch. Where there is hunger, there will be a Lion." — This became our sacred vow.
        </i>
      </p>

      <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
        ROOTED IN CULTURE AND FAITH
      </h3>

      <p>
       What made Hunger Week resonate so deeply was its connection to India's spiritual heritage.
        In Hindu philosophy, Anna Daan (gift of food) is revered as Maha Daan—the greatest gift. 
        The Sikh tradition of Langar inspired our community kitchen models. Islamic principles of Sadaqah,
         Christian teachings of serving the hungry, and Buddhist-Jain traditions of compassionate giving—all found expression in Lions' service.
        Feeding the hungry honours the best of every faith.
      </p>

      <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
        A WEEK OF EXTRAORDINARY ACTION
      </h3>

      <ul>
        <li>
          <b>Community Kitchens (Khichadi Ghar): </b> Thousands of community kitchens served hot, 
          nutritious meals at railway stations, slum colonies, hospitals, and construction sites—with dignity, not pity.
        </li>
        <li>
          <b>Food Donation Drives:</b> Clubs transformed into collection centres. Local businesses, religious institutions,
           and communities contributed provisions distributed to food-insecure families.
        </li>
        <li>
          <b>Hunger Relief Kits:</b> Ready-to-eat meal kits reached homeless individuals, migrant workers, and families in distress—packages of hope assembled with care.
        </li>
        <li>
          <b>School Nutrition:</b> Lions partnered with schools to provide midday meals and weekend meal packs, ensuring no child faces Monday hungry.
        </li>
        <li>
          <b>Senior Support:</b> Special attention to elderly citizens living alone, with meal deliveries and community lunches for ongoing support.
        </li>
      </ul>

      <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
        RECOGNISING EXCELLENCE: HUNGER WEEK AWARDS 2026
      </h3>

      <p>
       The overwhelming response to Hunger Week was reflected in the awards programme. 
       A total of <b> 617 nominations</b> were received from <b> 427 Clubs across 54 Districts and 12 Multiple Districts</b>—a testament to the nationwide participation.
      </p>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "15px",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f4f4f4" }}>
            <th style={{ border: "1px solid #ddd", padding: "10px" }}>
              Award Category
            </th>
            <th style={{ border: "1px solid #ddd", padding: "10px" }}>
              Winners
            </th>
          </tr>
        </thead>
        <thead>
            <tr>
                <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                    CLUB LEVEL AWARDS
                </th>
            </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
              C-21: Hunger Relief Impact Champion Award
            </td>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
              11 Clubs
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
            C-22: Hunger Relief Dignity Award	10 Clubs
            </td>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
              10 Clubs
            </td>
          </tr>
            <tr>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
            C-23: Hunger Relief Compassion in Action Award
            </td>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
              10 Clubs
            </td>
          </tr>
            <tr>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
            C-24: Hunger Relief Nutrition Advocate Award	
            </td>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
              10 Clubs
            </td>
          </tr>
            <tr>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
            C-25: Hunger Relief Zero Waste Hero Award	11 Clubs
            </td>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
              11 Clubs
            </td>
          </tr>




   <thead>
            <tr>
                <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                   DISTRICT LEVEL AWARDS
                </th>
            </tr>
        </thead>


          <tr>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
             D-26: District of Distinction Award	Districts
            </td>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
              320A, 3232F2
            </td>
          </tr>
            <tr>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
             D-27: Sustainability Trailblazer Award	Districts 
            </td>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
              320D, 3234D1
            </td>
          </tr>
            <tr>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
              D-28: Meals on Wheels Mobiliser Award	Districts 
            </td>
            <td style={{ border: "1px solid #ddd", padding: "10px" }}>
              320A, 3234D1
            </td>
          </tr>
        </tbody>
      </table>

      <p>
        Special congratulations to Lions Club of Gauhati Greater (322G) which won across four categories, 
        and Lions Club of Bilimora (3232F2) with three awards—exemplifying outstanding commitment to hunger relief.
      </p>

      <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
        THE COLLECTIVE ROAR
      </h3>

      <p>
       The response from Multiple District 322 was particularly remarkable, leading with 130 nominations, followed by MD 317 (83), MD 320 (62), and MD 3233 (52).
        This pan-India participation demonstrated that hunger relief transcends regional boundaries when Lions unite with purpose.
      </p>

      <p>
        The volunteers—Lions, Leos, family members, and community supporters—discovered something profound: in feeding others, they themselves were nourished. 
        The smiles of gratitude, the tears of relief, the simple words of thanks—these became treasures that no amount of money could buy.
      </p>

      <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
        THE JOURNEY CONTINUES
      </h3>

      <p>
       International President Lion A. P. Singh's vision of holistic service—Mind, Body, 
       Planet—continues to guide us. Having addressed mental wellness and hunger, 
       we now prepare for Environment Protection Week (April 18–26, 2026). The trilogy of service will be complete, but the spirit of Lionism endures.
      </p>

      <p>
        <b>
          "When we feed one person, we nourish humanity. When Lions unite,
          hunger doesn't stand a chance."
        </b>
      </p>
    </div>
  );
};

export default HungerBlog;